import React from 'react';
import styles from './Badge.module.css';

const VARIANT_CLASSES = {
  neutral: styles.neutral,
  brand: styles.brand,
  accent: styles.accent,
  success: styles.success,
  warning: styles.warning,
  danger: styles.danger,
  info: styles.info
};

export default function Badge({ variant = 'neutral', children, icon }) {
  return (
    <span className={[styles.badge, VARIANT_CLASSES[variant] || VARIANT_CLASSES.neutral].join(' ')}>
      {icon ? <span className={styles.icon}>{icon}</span> : null}
      {children}
    </span>
  );
}
